import axios from 'axios';
import { useContext, useState } from 'react';
// import { useNavigate } from 'react-router-dom'
import { BASE_URL } from '../../utils/Constants';
import cookies from 'js-cookie';
import AuthContext from '../../store/auth-context';
import "./authForm.css"
import Swal from 'sweetalert2';
const AuthForm = () => {
  // const navigate = useNavigate();
  const [isLogin, setIsLogin] = useState(true);
  const [Email, setEmail] = useState("");
  const [Password, setPassword] = useState("");

  const switchAuthModeHandler = () => {
    // navigate("/signup")
  };
  const AuthCtx = useContext(AuthContext)


  const submitHandler = (e: any) => {
    e.preventDefault();
    axios.post(`${BASE_URL}/auth/login.php`, { email: Email, password: Password }).then((res: any) => {
       
       if(res.data.data){

         AuthCtx.Login(res.data.data)
        }else{
          Swal.fire("" , "Email or password incorrect, please try again" , "error")
        }

      // navigate("/")

    })
  }

  return (
   
      <div className=" login-container text-center ">
            <div className="row">
              <div className="col-3"></div>
                <div className=" col-6 login-form-1 ">
                   
                    <form onSubmit={submitHandler}>
                        <div className="form-group">
                           <label className="form-label">Email : </label>
                            <input type="email" className="form-control " required placeholder="Your Email *"  onChange={(e:any)=>{setEmail(e.target.value)}} />
                        </div>
                        <div className="form-group">
                        <label className="form-label">Password : </label>
                            <input type="password" className="form-control " required style={{color:"white !important"}} placeholder="Your Password *"  onChange={(e:any)=>{setPassword(e.target.value)}} />
                        </div>
                        <div className="form-group">
                            <input type="submit" className="btnSubmit" value="Login" />
                        </div>
                       
                    </form>
                </div>
               <div className="col-3"></div>
            </div>
        </div>
   
  );
};

export default AuthForm;
